import SelectAsyncPagination from './select-async-pagination';

export default SelectAsyncPagination;
